import React, { useEffect } from 'react';
import { useForm, useFormState } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Box, Divider } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { updateTrayProps } from '../../../../../../redux/modules/tray';
import InsuredContactSection from '../InsuredContactSection';
import InsuredInfoSection from '../InsuredInfoSection';
import InsuredRequiredInfoSection from '../InsuredRequiredInfoSection';

const InsuredForm = ({ formId, onSubmit }) => {
  const dispatch = useDispatch();
  const useFormMethods = useForm();
  const { handleSubmit, control } = useFormMethods;
  const { isDirty } = useFormState({ control });

  useEffect(() => {
    if (isDirty) {
      dispatch(updateTrayProps({ formIsDirty: isDirty }));
    }
  }, [isDirty]);

  return (
    <form dusk={formId} id={formId} onSubmit={handleSubmit(onSubmit)}>
      <Box pb={2}>
        <InsuredRequiredInfoSection useFormMethods={useFormMethods} />
      </Box>
      <Divider borderBottomWidth="3px" ml={-6} pl={12} />
      <InsuredInfoSection useFormMethods={useFormMethods} />
      <InsuredContactSection useFormMethods={useFormMethods} />
    </form>
  );
};

InsuredForm.propTypes = {
  formId: PropTypes.string.isRequired,
  onSubmit: PropTypes.func
};

export default InsuredForm;
